import type { TFunction } from 'i18next';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@ui/dialog.tsx';
import { Button } from '@ui/button.tsx';

export interface HierarchyRelationCascadeChoice {
  mode: 'trash' | 'cut';
  linkId: number;
  target: string;
  name: string;
}

interface HierarchyRelationCascadeDialogProps {
  t: TFunction;
  /** `null` = fermée. */
  choice: HierarchyRelationCascadeChoice | null;
  onConfirm: (cascade: boolean) => void;
  onCancel: () => void;
}

/**
 * Choix cascade en attente (cible avec sa propre équipe) — une vraie Dialog,
 * pas un toast : texte trop long pour tenir dans un encart coin d'écran.
 * Extrait de `sales-hierarchy-canvas.tsx` (composant trop volumineux).
 */
export function HierarchyRelationCascadeDialog({
  t,
  choice,
  onConfirm,
  onCancel
}: HierarchyRelationCascadeDialogProps) {
  return (
    <Dialog
      open={choice !== null}
      onOpenChange={(open) => {
        if (!open) onCancel();
      }}
    >
      <DialogContent className="w-fit min-w-[24rem] max-w-[90vw]">
        {choice && (
          <>
            <DialogHeader>
              <DialogTitle>
                {t(`admin.hierarchy.relation.${choice.mode}.confirm.with_team.title`, {
                  name: choice.name
                })}
              </DialogTitle>
            </DialogHeader>
            <DialogFooter className="flex-col gap-1.5 sm:flex-col sm:justify-start sm:space-x-0">
              <Button variant="destructive" className="w-full" onClick={() => onConfirm(true)}>
                {t(`admin.hierarchy.relation.${choice.mode}.confirm.with_team.cascade`, {
                  name: choice.name
                })}
              </Button>
              <Button variant="outline" className="w-full" onClick={() => onConfirm(false)}>
                {t(`admin.hierarchy.relation.${choice.mode}.confirm.with_team.keep`, {
                  name: choice.name
                })}
              </Button>
              <Button variant="ghost" className="w-full" onClick={onCancel}>
                {t('admin.hierarchy.relation.cancel')}
              </Button>
            </DialogFooter>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
